import React, { useState, useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { Row, Col, Collapse, Message, Icon, Spin } from 'antd';
import axios from 'axios';
import {
  StyledDemonstration,
  StyledRenderObjectThumResultRow,
  StyledRenderRecognizeFaceRow,
  StyledTrigonSpan,
  StyledCenterItem
} from '../../styled-components/product/product-demonstration';
import RequestAPI from './RequestAPI';
import CanvasDrawer from './CanvasDrawer/CanvasDrawer';
import {
  handsGestureResp,
  handsRecognizeFaceResp,
  handleFacePropertyResp,
  handleBodyDetectResp,
  handleExpregResp
} from './RequestArgsPorcesser';
import UploadImg2base64 from './UploadImg2base64';
import expregdemo1 from '../../images/production/ai-expreg-demo1.jpg';
import expregdemo2 from '../../images/production/ai-expreg-demo2.jpg';
import expregdemo3 from '../../images/production/ai-expreg-demo3.jpg';
import expregdemo4 from '../../images/production/ai-expreg-demo4.jpg';

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const handsGesture =
  'https://openplantform.oss-cn-beijing.aliyuncs.com/canvastest/hands-gesture-one.jpg?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=4741673140&Signature=4eXgYCSB%2B7Z9TJsV3B1qbVUsqgQ%3D';
const handsGesture1 =
  'https://openplantform.oss-cn-beijing.aliyuncs.com/canvastest/hands-gesture-two.jpg?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=4741673166&Signature=MY%2B2YiuesMgOAIvE1cafE1BxMF4%3D';
const handsGesture2 =
  'https://openplantform.oss-cn-beijing.aliyuncs.com/canvastest/hands-gesture-three.jpg?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=4741639556&Signature=xZdZuxDHOsVS%2FIIA2lwgRyVa%2FV0%3D';
const handsGesture4 =
  'https://openplantform.oss-cn-beijing.aliyuncs.com/canvastest/hands-gesture-six.jpg?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=4741673191&Signature=hmiB19OBo0bAeawIxxHR1BQrgN4%3D';
const handsGesture5 =
  'https://openplantform.oss-cn-beijing.aliyuncs.com/canvastest/hands-gesture-good.png?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=4742853302&Signature=rQpfH8RFvc8wIrXd9n7Pen8N%2FKU%3D';
const face1 =
  'https://openplantform.oss-cn-beijing.aliyuncs.com/canvastest/1.png?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=5177102482&Signature=GHj2vkwSC%2BA5WLYJ8nNfDHev%2FYk%3D';
const face2 =
  'https://openplantform.oss-cn-beijing.aliyuncs.com/canvastest/2.png?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=5177102499&Signature=7HZ2%2FNbKr90kPDKrgTJ3iSw%2Biw0%3D';
const face3 =
  'https://openplantform.oss-cn-beijing.aliyuncs.com/canvastest/3.png?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=5177102513&Signature=bEsVK6vqOq%2FqwO97fRCdF%2FNAVCk%3D';
const face4 =
  'https://openplantform.oss-cn-beijing.aliyuncs.com/canvastest/4.png?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=5177102525&Signature=RnCfIcjjRCsJMH99dOQKfOWTkkA%3D';
const bodydemo1 =
  'https://openplantform.oss-cn-beijing.aliyuncs.com/canvastest/bodyProp1.png?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=5177102590&Signature=6HSzS57SLCCvJVWYmDO9l%2BCX9y4%3D';
const bodydemo2 =
  'https://openplantform.oss-cn-beijing.aliyuncs.com/canvastest/bodyProp2.png?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=5177102603&Signature=KaUqKJ4F3Dpi41oA0fWHF5WYIHQ%3D';

const trialPicture = [
  handsGesture,
  handsGesture1,
  handsGesture2,
  handsGesture4,
  handsGesture5
];
const facePropty = [face1, face2, face3, face4];
const bodydemo = [bodydemo1, bodydemo2];
const expregdemo = [expregdemo1, expregdemo2, expregdemo3, expregdemo4];

const { Panel } = Collapse;
const ReactJson = dynamic(import('react-json-view'), { ssr: false });
let tokenI = 1;
const requestMethods = {
  handsGesture: {
    // 手势识别
    method: '/aiimage/novabell/hands-gesture',
    responseKey: 'points',
    respProcessor: handsGestureResp,
    base64: {
      key: 'picture'
    },
    url: {
      key: 'url'
    },
    detailContext: 'OcrContextShow',
    demoPic: trialPicture,
    showRequestText: {
      Params: {
        picture: '图片的Base64编码',
        url: '图像地址'
      }
    }
  },
  faceProperty: {
    // 人脸属性
    method: '/aiimage/face-property',
    respProcessor: handleFacePropertyResp,
    url: {
      key: 'image_url'
    },
    base64: {
      key: 'image_base64'
    },
    props: {
      // 固定参数
      properties: ['emotion', 'lightness']
    },
    detailContext: 'OcrContextShow',
    demoPic: facePropty,
    showRequestText: {
      Params: {
        image_base64: '图片的Base64编码',
        image_url: '图片的url地址',
        properties:
          "需要识别的属性，数组为空返回人脸基本信息，(不填只做人脸检测）['emotion', 'lightness'] )", // eslint-disable-line
        set_face_confidence:
          '设置人脸检测用于裁剪出人脸小图的置信度c，范围c∈[0~1]，默认值0.7',
        user_info:
          '用户标识数据，string长度限制为128字符；超出长度或者类型错误时参数报错。只要填写就会按照用户的原始输入做数据回流'
      }
    }
  },
  bodyDetect: {
    // 人体属性
    method: '/aiimage/body-detect',
    respProcessor: handleBodyDetectResp,
    url: {
      key: 'image_url'
    },
    base64: {
      key: 'image_base64'
    },
    props: {
      body_proberty: {
        detect: 'offline_0',
        hand_up: 'offline_1'
      }
    },
    detailContext: 'OcrContextShow',
    demoPic: bodydemo,
    showRequestText: {
      Params: {
        image_base64: '图片的Base64编码',
        image_url: '图片的url地址',
        body_property: '选择需要识别的人体相关特征 {model:name}'
      }
    }
  },
  recognizeFace: {
    // 人脸搜索
    method: '/aiimage/faceid/recognize-face',
    url: {
      key: 'image_url'
    },
    base64: {
      key: 'image_base64'
    },
    props: {
      person_id_list: [
        '7e403a9c-01d3-4cee-88e5-922a9e099e41',
        '1e8855f4-664b-4392-9882-1270baa1d292',
        '218d5375-e815-4509-8f36-4606d1dfeee3',
        'ffaba559-6675-4c37-99a1-8d335e294d95'
      ]
    },
    respProcessor: handsRecognizeFaceResp,
    demoPic: facePropty,
    detailContext: 'RecognizeFaceShow',
    notShowInCanvas: true,
    showRequestText: {
      Params: {
        image_base64: '图片的Base64编码',
        image_url: '图片的url地址',
        person_id_list: '需要识别的人员id列表',
        min_face_size: '需要识别的最小人脸尺寸，默认长和宽均30，最小值为30',
        max_person_num: '相似度最高的N个人的id，取值范围：[1, 10]，默认值：3'
      }
    }
  },
  expreg: {
    // 拍照口算批改
    method: '/aiocr/expreg',
    url: {
      key: undefined
    },
    base64: {
      key: 'image'
    },
    demoPic: expregdemo,
    respProcessor: handleExpregResp,
    props: {
      // 固定参数
      sid: 'xueersi_ai_ocr_correct_calculation_all',
      token: `xiaoming${Date.now() + (tokenI += 1)}`
    },
    showThumb: 'expreg',
    requestMustBase64: true,
    showRequestText: {
      Params: {
        token: '唯一标识符，建议用 学生ID_时间戳',
        sid: '项目标识，固定值“xueersi_ai_ocr_correct_calculation_all”',
        image: '传入图片base64数据\n'
      }
    }
  }
};
const pageMethod = {
  'fr-gr': 'handsGesture',
  'ic-oral': 'expreg',
  'fr-fs': 'recognizeFace',
  'fr-hd': 'bodyDetect',
  'fr-fdaa': 'faceProperty',
  's-coc': 'expreg'
};

const errorMsg = {
  3006027777: '批改出现了问题',
  3006020100: '数据格式有误',
  3005034000: '缺少参数',
  3005034001: '非法url',
  3005034002: '大小超过4M',
  3005034003: '图片格式错误',
  3005034004: '错误的请求',
  3005035001: '下载图片失败',
  3005035002: '未知错误',
  3005035003: '读取模型失败',
  3005035004: '识别失败',
  3005035005: '下载超时',
  3005035006: '文件写入失败',
  300009001: '输入参数错误',
  300009002: '无图片数据',
  300009003: '图片数据错误',
  300009004: '图片链接地址错误',
  300009005: '下载图片失败',
  300009006: 'base64解析图片失败',
  300009007: '检测模型类型为空',
  300009008: 'opencv解析图片失败',
  300009009: '错误的检测类型',
  300009010: '解析图片数据为空',
  300009011: '分辨率过大',
  300010001: '输入参数错误',
  300010002: '无图片数据',
  300010003: '图片数据错误',
  300010004: '图片链接地址错误',
  300010005: '下载图片失败',
  300010006: 'base64解析图片失败',
  300010007: '检测模型类型为空',
  300010008: 'opencv解析图片失败',
  300010009: '错误的检测类型',
  300010010: '解析图片数据为空',
  300601001: '请求参数是非法json',
  300601002: '参数错误',
  300601003: 'image_url和image_base64不能同时为空',
  300601045: 'image_url不是字符串类型',
  300601046: 'image_base64不是字符串类型',
  300601019: 'person_id_list不能为空',
  300601037: 'person_id_list类型错误',
  300601053: 'person_id_list中的元素不是字符串类型',
  300601054: 'min_face_size不是int类型',
  300601027: '非法的最小人脸尺寸',
  300601020: 'max_person_num超出取值范围',
  300601055: 'max_person_num不是int类型',
  300601023: '部分person_ids不存在',
  300601013: '下载图片失败',
  300601008: '不支持的图片分辨率',
  300601032: '人脸检索失败',
  300601056: '请求包体不是一个json对象'
};
const quickSort = (arr, key) => {
  if (arr.length < 2) {
    return arr;
  }
  const pivotIndex = Math.floor(arr.length / 2);
  const pivot = arr.splice(pivotIndex, 1)[0];
  const left = [];
  const right = [];
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][key] > pivot[key]) {
      left.push(arr[i]);
    } else {
      right.push(arr[i]);
    }
  }
  return quickSort(left, key).concat([pivot], quickSort(right, key));
};

const RecognizeFaceResultLists = ({ picGroup, result, personIdList }) => {
  if (
    !(Array.isArray(picGroup) && Array.isArray(result) && result.length > 0)
  ) {
    return <></>;
  }
  const renderCandidateMap = (idMap, index) => {
    return idMap.candidate[personIdList[index]] || '';
  };
  const urlMapArray = picGroup.map((picItem, index) => ({
    picItem,
    percent: renderCandidateMap(result[0], index) || 0
  }));
  const sortArray = quickSort(urlMapArray, 'percent');
  return sortArray.map((picItem, index) => {
    return (
      <li key={picItem.picItem}>
        <img src={picItem.picItem} alt="" />
        <StyledTrigonSpan content={index + 1} />
        <p>{`相似度为${picItem.percent}%`}</p>
      </li>
    );
  });
};

const TalFunctionDemonstration = ({ production }) => {
  // eslint-disable-next-line no-unused-vars
  const [response, setResponse] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [result, setResult] = useState([]);
  const [activeSelectIndex, setActiveSelectIndex] = useState(0);
  const [canvasBackground, setCanvasBackground] = useState(null);
  const [showOcrPicData, setShowOcrPicData] = useState(null);
  const { name } = production;
  const [requestMethod] = useState(
    requestMethods[pageMethod[name]] || 'handsGesture'
  );
  const [showOcrResult, setShowOcrResult] = useState(
    !!requestMethod.notShowInCanvas
  );
  const [spinning, setSpinning] = useState(false);

  const OcrContextShow = () => {
    const detailPic = useRef(null);
    useEffect(() => {
      if (!result || !canvasBackground) {
        return;
      }
      const thumbCanvasWidth = 150;
      const thumbCanvasHeight = 150;
      const canvas = detailPic.current;
      const ctx = canvas.getContext('2d');
      const { points } = showOcrPicData;
      const thumbWidth = points[1][0] - points[0][0];
      const thumbHeight = points[2][1] - points[1][1];
      const scaleX = thumbCanvasWidth / thumbWidth;
      const scaleY = thumbCanvasHeight / thumbHeight;
      let moveY = 0;
      let moveX = 0;
      if (scaleX > scaleY) {
        moveX = (thumbCanvasWidth - thumbWidth * scaleY) / 2;
        // eslint-disable-next-line max-len
        ctx.drawImage(
          canvasBackground,
          points[0][0],
          points[0][1],
          thumbWidth,
          thumbHeight,
          moveX,
          0,
          thumbWidth * scaleY,
          thumbCanvasHeight
        );
      } else {
        moveY = (thumbCanvasHeight - thumbHeight * scaleX) / 2;
        // eslint-disable-next-line max-len
        ctx.drawImage(
          canvasBackground,
          points[0][0],
          points[0][1],
          thumbWidth,
          thumbHeight,
          0,
          moveY,
          thumbCanvasWidth,
          thumbHeight * scaleX
        );
      }
      ctx.stroke();
    }, [detailPic]);
    return (
      <StyledRenderObjectThumResultRow>
        <Col span={10} push={2} className="ocrResult">
          <canvas ref={detailPic} width="150" height="150" />
        </Col>
        <Col span={10} push={2} className="ocrResultContent">
          <ul>
            识别结果:
            {
              // eslint-disable-next-line max-len
              Array.isArray(showOcrPicData.text)
                ? showOcrPicData.text.map((content) => {
                    return (
                      <li key={content.key}>
                        {content.key}：{content.value}
                      </li>
                    );
                  })
                : showOcrPicData.text
            }
            <li />
          </ul>
        </Col>
      </StyledRenderObjectThumResultRow>
    );
  };
  const RecognizeFaceShow = ({ background, points, serverWidth }) => {
    if (!background) {
      return <></>;
    }
    return (
      <StyledRenderRecognizeFaceRow>
        <Col span={11} className="recognizeFaceResult">
          <CanvasDrawer
            width="350"
            height="404"
            backgroundImg={background}
            pointsGroup={points}
            onlineScale={background.width / serverWidth}
          />
        </Col>
        <Col span={11} push={2} className="recognizeFaceCompare">
          {/* <p className="recognizeFaceResultTitle">查找结果</p> */}
          <ul>
            <RecognizeFaceResultLists
              picGroup={requestMethod.demoPic}
              result={result}
              personIdList={requestMethod.props.person_id_list}
            />
          </ul>
        </Col>
      </StyledRenderRecognizeFaceRow>
    );
  };
  const handleShowOcrResult = (thumb) => {
    setShowOcrResult(true);
    setShowOcrPicData(thumb);
  };
  const showPictureInCanvas = (imgurl, base64) => {
    const imgDom = document.createElement('img');
    imgDom.src = imgurl || base64;
    imgDom.onload = () => {
      setCanvasBackground(imgDom);
    };
  };
  const drawImg2base64 = async (url) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        responseType: 'blob',
        url
      })
        .then((resp) => {
          const fr = new FileReader();
          fr.onload = () => {
            resolve(fr.result);
          };
          fr.readAsDataURL(resp.data);
        })
        .catch((e) => reject(e));
    });
  };
  const identifyingImg = useCallback(async (imgurl, base64, _this, index) => {
    setActiveSelectIndex(index !== undefined ? index : -1);
    setSpinning(true);
    let fileBase64;
    let localBase64;
    setResponse({});
    setResult([]);
    if (base64) {
      // eslint-disable-next-line prefer-destructuring
      fileBase64 = base64.split(',')[1];
      localBase64 = base64;
    }
    if (requestMethod.requestMustBase64 && !base64) {
      localBase64 = await drawImg2base64(imgurl);
      // eslint-disable-next-line prefer-destructuring
      fileBase64 = localBase64.split(',')[1];
    }
    if (requestMethod.notShowInCanvas) {
      setShowOcrResult(true);
      showPictureInCanvas(imgurl, localBase64);
    } else {
      setShowOcrResult(false);
      showPictureInCanvas(imgurl, localBase64);
    }
    RequestAPI(requestMethod, imgurl, fileBase64)
      .then(({ data, processArgs }) => {
        setSpinning(false);
        setResponse(data);
        setResult(processArgs);
      })
      .catch((err) => {
        setSpinning(false);
        Message.error(errorMsg[err.code] || '服务器异常');
        setResponse({});
      });
  });

  useEffect(() => {
    identifyingImg(requestMethod.demoPic[0], undefined, undefined, 0);
    // eslint-disable-next-line
  }, []);
  const CanvasThumbnail = ({ thumb }) => {
    const thumCanvas = useRef(null);
    const thumbCanvasWidth = 120;
    const thumbCanvasHeight = 120;
    useEffect(() => {
      if (canvasBackground && thumb) {
        const canvas = thumCanvas.current;
        const ctx = canvas.getContext('2d');
        const { points } = thumb;
        const thumbWidth = points[1][0] - points[0][0];
        const thumbHeight = points[2][1] - points[1][1];
        const scaleX = thumbCanvasWidth / thumbWidth;
        const scaleY = thumbCanvasHeight / thumbHeight;
        let moveY = 0;
        let moveX = 0;
        if (scaleX > scaleY) {
          moveX = (thumbCanvasWidth - thumbWidth * scaleY) / 2;
          // eslint-disable-next-line max-len
          ctx.drawImage(
            canvasBackground,
            points[0][0],
            points[0][1],
            thumbWidth,
            thumbHeight,
            moveX,
            0,
            thumbWidth * scaleY,
            thumbCanvasHeight
          );
        } else {
          moveY = (thumbCanvasHeight - thumbHeight * scaleX) / 2;
          // eslint-disable-next-line max-len
          ctx.drawImage(
            canvasBackground,
            points[0][0],
            points[0][1],
            thumbWidth,
            thumbHeight,
            0,
            moveY,
            thumbCanvasWidth,
            thumbHeight * scaleX
          );
        }
        ctx.stroke();
      }
    }, [thumb]);
    return (
      // eslint-disable-next-line max-len
      <canvas
        width={thumbCanvasWidth}
        height={thumbCanvasHeight}
        ref={thumCanvas}
        onClick={() => {
          handleShowOcrResult(thumb);
        }}
      />
    );
  };
  const ShowOcrResultDetail = () => {
    if (requestMethod.detailContext === 'OcrContextShow') {
      return <OcrContextShow />;
    }
    if (requestMethod.detailContext === 'RecognizeFaceShow') {
      return (
        <RecognizeFaceShow background={canvasBackground} points={result} />
      );
    }
    return <></>;
  };
  return (
    <StyledDemonstration>
      <Spin indicator={antIcon} spinning={spinning}>
        <Row>
          <Col span={16} className="identifying_content">
            <Row>
              <Col span={24} className="canvasBox">
                {requestMethod.detailContext !== 'RecognizeFaceShow' &&
                  canvasBackground && (
                    <CanvasDrawer
                      width="866"
                      height="524"
                      backgroundImg={canvasBackground}
                      pointsGroup={result}
                      onlineScale={
                        response && response.width && canvasBackground
                          ? canvasBackground.width / response.width
                          : 1
                      }
                    />
                  )}
                {showOcrResult && <ShowOcrResultDetail />}
                <Col className="thum_group" span={3} push={20}>
                  {requestMethod.detailContext !== 'RecognizeFaceShow' &&
                    requestMethod.showThumb !== 'expreg' &&
                    result &&
                    result.map((target) => {
                      return (
                        <CanvasThumbnail thumb={target} key={target.points} />
                      );
                    })}
                </Col>
              </Col>
              <Row className="identifying_upload">
                <Col span={19} offset={1}>
                  <small>
                    图片文件类型支持PNG、JPG、JPEG、BMP，图片大小不超过2M
                  </small>
                </Col>
                <Col span={3}>
                  {/* eslint-disable-next-line max-len */}
                  <UploadImg2base64
                    onFileReady={(data) => {
                      identifyingImg(undefined, data);
                    }}
                  />
                </Col>
              </Row>
            </Row>
            <StyledCenterItem>
              {Array.isArray(requestMethod.demoPic) &&
                requestMethod.demoPic.map((src, index) => (
                  <Col
                    span={
                      requestMethod.demoPic.length > 4
                        ? Math.floor(24 / requestMethod.demoPic.length)
                        : 6
                    }
                    key={src}
                    className={`identifyingImgBox ${
                      activeSelectIndex === index ? 'activeIndex' : ''
                    }`}
                  >
                    <img
                      src={src}
                      alt="手势识别"
                      onClick={(e) => {
                        e.preventDefault();
                        identifyingImg(src, undefined, e.target, index);
                      }}
                      role="presentation"
                    />
                  </Col>
                ))}
            </StyledCenterItem>
          </Col>
          <Col span={8} className="identifying_result">
            <Collapse accordion defaultActiveKey="result">
              {!requestMethod.notShowInCanvas && (
                <Panel header="识别结果" key="result">
                  <ul>
                    {result &&
                      result.map((resultItem, index) => {
                        return (
                          // eslint-disable-next-line react/no-array-index-key
                          <li
                            key={JSON.stringify(resultItem.text) + index}
                            className="result_text"
                          >
                            <span>{`${index + 1}：`}</span>
                            <span>
                              {Array.isArray(resultItem.text)
                                ? resultItem.text.map((item) => {
                                    return `${item.key}: ${item.value}   `;
                                  })
                                : resultItem.text}
                            </span>
                          </li>
                        );
                      })}
                  </ul>
                </Panel>
              )}
              <Panel header="Request" key="2" style={{ display: 'none' }}>
                <ReactJson src={requestMethod.showRequestText} />
              </Panel>
              <Panel header="Response" key="3">
                <ReactJson src={response} />
              </Panel>
            </Collapse>
          </Col>
        </Row>
      </Spin>
    </StyledDemonstration>
  );
};

TalFunctionDemonstration.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    desc: PropTypes.string
  })
};

export default TalFunctionDemonstration;
